import { compose, map, addIndex } from 'ramda';

const optionsByArray = compose(
  addIndex(map)((value, index) => ({ value: index, label: value })),
);

export {
  optionsByArray,
};
